import React, { useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { Container, Col, Row } from 'react-bootstrap'
import SharedTitle from '~/components/UI/SharedTitle'
import Text from '~/components/UI/Text'
import { useTranslation, Trans } from '~/i18n'
import Box from '~/components/UI/Box'
import Icon from '~/components/UI/Icon'
import { COLORS } from '~/components/UI/Constants'
import appendCDN from '~/utils/append_cdn_link'
import breakpoints from '../UI/breakpoints'
import lottie from 'lottie-web'

const MyContainer = styled.div`
  padding: 40px 0;
`

const StyledIcon = styled(Icon)`
  font-size: 48px;
  margin-right: 15px;
  ::before {
    color: ${COLORS.PRIMARY};
  }
  ${breakpoints.md} {
    margin-right: 24px;
  }
`

const Img = styled.div`
  width: auto;
  height: 100%;
  max-height: 400px;
`

const Title1 = styled(SharedTitle)`
  display: block;
  ${breakpoints.md} {
    display: none;
  }
`
const Title2 = styled(SharedTitle)`
  display: none;
  ${breakpoints.md} {
    display: block;
  }
`

const Section2ExplainOwner = () => {
  const [t] = useTranslation()

  const initLottie = useCallback(() => {
    const el = document.getElementById('lottie-house')
    if (el) {
      lottie.loadAnimation({
        container: el, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: appendCDN('lottie/house.json') // the path to the animation json
      });
    }
  }, [])

  useEffect(() => {
    initLottie()
  }, [initLottie])

  return (
    <MyContainer>
      <Container>
        <Row>
          <Col className='mb-5' md={5} lg={6}>
            <Title1 centered padding='0'>
              {t`“Phần sở hữu” là gì?`}
            </Title1>
            <Img id='lottie-house' />
          </Col>
          <Col md={7} lg={6}>
            <Box flex column justify='center'>
              <Title2 padding='0 0 24px 0'>
                {t`“Phần sở hữu” là gì?`}
              </Title2>
                <Text>
                  <Trans i18nKey='TR_EXPLAIN_OWNER_PROPERTY_1'></Trans>
                </Text>
              <Box flex align='center' height='auto' padding='24px 0'>
                <StyledIcon name='share-1' />
                <StyledIcon style={{ fontSize: 12 }} name='straight-arrow-' />
                <StyledIcon name='share-2' />
                <StyledIcon style={{ fontSize: 12 }} name='straight-arrow-' />
                <StyledIcon name='share-3' />
              </Box>
              <Text>
                <Trans i18nKey='TR_EXPLAIN_OWNER_PROPERTY_2'></Trans>
              </Text>
            </Box>
          </Col>
        </Row>
      </Container>
    </MyContainer>
  )
}

export default Section2ExplainOwner
